var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-devices"},[_c('div',{staticClass:"media-device ma-2"},[_c('media-device')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }